import { ssoHttp } from "../base"
import {TOKEN_CONFIG} from "../config"


export async function postAuthentication(formData) {
  console.log("postAuthentication:", formData,   TOKEN_CONFIG.AICS_TOKEN )
    try {
        const response = await ssoHttp.post(
            `v1/users/authentication`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Auth-Token': TOKEN_CONFIG.AICS_TOKEN 
          }
        }
    )
    return response
    } catch (error) {
        return error
    }
}

export async function postAuthenticationChange(formData) {
  console.log("postAuthenticationChange 提交数据:");
  
  for (let pair of formData.entries()) {
    console.log(pair[0] + ': ', pair[1]);
  }  
  try {
    const response = await ssoHttp.post(
      `v1/users/authentication_change`,
      formData,      
      {
        headers: { 
                    'X-Auth-Token': TOKEN_CONFIG.AICS_TOKEN 
         }      
  })
    console.log("postAuthenticationChange 响应:", response)
    return response
  } catch (error) {
    console.error("postAuthenticationChange 错误:", error)
    
    if (error.response) {
      console.error("错误响应状态:", error.response.status)
      console.error("错误响应数据:", error.response.data)
    }
    
    throw error
  }
}
